import React from 'react';
import { number } from 'prop-types';
import { quotesPropType } from '../../utils/propTypes';
import QuotesDetailsBox from './QuotesDetailsBox';

const QuotesCompactList = ({ quotes, maxListSize }) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-3 sui-mb-8">
      {quotes.slice(0, maxListSize).map((quote) => (
        <QuotesDetailsBox key={quote.id} quote={quote} />
      ))}
    </div>
  );
};

QuotesCompactList.propTypes = {
  maxListSize: number,
  quotes: quotesPropType,
};

QuotesCompactList.defaultProps = {
  maxListSize: 3,
  quotes: [],
};

export default QuotesCompactList;